import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';
import { confirmAlert } from 'react-confirm-alert'; // Import
import {debounce,delay} from 'lodash';
import {PatientTodaysRecordRateDataListAction,deletePatientTodaysRecordRateDataAction,UpdateCollectedBehaviorData,SavePatientRecordRateData} from '../../actions/BehaviourDataActions';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';
import { isFloat, renderTextField,isInteger} from '../../../../../../../../components/reduxFields';
import moment from 'moment';
import { change, Field, reduxForm } from 'redux-form';


class RecordRateDataViewModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
            creadtedDate: props.creadtedDate
        }
        this.handleDurationChange = this.handleDurationChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    componentWillMount = () => {
        this.props.PatientTodaysRecordRateDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
    }

    componentWillReceiveProps(nextProps) {
        (nextProps.patientTodaysRecordRateDataList && nextProps.patientTodaysRecordRateDataList.data.PatRecordRateData || []).forEach((obj, index) => {
            this.props.dispatch(change('RecordRateDataViewModalForm', `Behavior[${index}].duration`, obj.duration || 0));
        });
        (nextProps.patientTodaysRecordRateDataList && nextProps.patientTodaysRecordRateDataList.data.PatRecordRateData || []).forEach((obj, index) => {
            this.props.dispatch(change('RecordRateDataViewModalForm', `Behavior[${index}].value`, obj.value || 0));
        });
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDurationChange = async(event, data, action,name) => {      
        let finalData = [];      

        let patientRecordFrequencyDataDetailsModelData = {
            "recordRateDataDetailId":data.recordRateDataDetailId,
            "recordRateDataId": data.id,
            "behaviorsReductionId": data.behaviorsReductionId,                
            "value": data.value
        }
        finalData.push(patientRecordFrequencyDataDetailsModelData);

        let postData = {
            "id": data.id,
            "patientId": this.state.patientId,
            "sessionId": data.sessionId,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            "patientRecordRateDataDetailsModel": finalData,
            "duration": event.target.value,
        }

        try {
            this.props.dispatch(change('RecordRateDataViewModalForm', name , event.target.value || 0));
            let patientId = this.state.patientId;
            let createdDate = this.state.creadtedDate;
            let uuid = this.props.uuid;
            let res = await  this.props.SavePatientRecordRateData(postData,{
                patientId,
                createdDate,
                uuid
            });
            // console.log(res);
            // delay(()=>this.props.PatientTodaysRecordRateDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate),100)



        } catch (error) {

        }

    }
    deBouncedHandleDurationChange = debounce(this.handleDurationChange,1000);

    handleValueChange = async (event, data, action,name) => {


        let finalData = [];      

        let patientRecordFrequencyDataDetailsModelData = {
            "recordRateDataDetailId":data.recordRateDataDetailId,
            "recordRateDataId": data.id,
            "behaviorsReductionId": data.behaviorsReductionId,                
            "value": event.target.value
        }
        finalData.push(patientRecordFrequencyDataDetailsModelData);

        let postData = {
            "id": data.id,
            "patientId": this.state.patientId,
            "sessionId": data.sessionId,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            "patientRecordRateDataDetailsModel": finalData,
            "duration": data.duration,
        }

        try {
            this.props.dispatch(change('RecordRateDataViewModalForm', name , event.target.value || 0));
            let patientId = this.state.patientId;
            let createdDate = this.state.creadtedDate;
            let uuid = this.props.uuid;
            let obj = {
                patientId,
                createdDate,
                uuid
            }
            let res = await this.props.SavePatientRecordRateData(postData,obj);

            // delay(()=>this.props.PatientTodaysRecordRateDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate),100)



        } catch (error) {

        }
    }

    deBounceHandleValueChange = debounce(this.handleValueChange,1000)

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        
        confirmAlert({
            title: 'Delete Selected Rate Data',
            message: 'Are you sure you want to delete this Rate Data?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientTodaysRecordRateDataAction(Obj.recordRateDataDetailId, this.state.patientId, this.props.uuid, this.state.creadtedDate)
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (patientTodaysRecordRateDataList) => {
        patientTodaysRecordRateDataList = patientTodaysRecordRateDataList || [];
        if (!patientTodaysRecordRateDataList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientTodaysRecordRateDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>
                    <td>{showFormatedDateandTime(Obj.sessionDate)}</td>
                    <td>
                        <Field
                            name={`Behavior[${index}].duration`}
                            type="text"
                                maxLength="4"
                                label="Duration In Min."
                                component={renderTextField}
                                normalize={isFloat}
                                disabled={ this.props.updatePermissionBehavior ? false: true}
                                onChange={(event) => this.deBouncedHandleDurationChange(event, Obj, 'DURATION',`Behavior[${index}].duration`)}
                            />
                            <small>(Ex: 15 sec = 0.25 min)</small>
                    </td>
                    <td>
                            <Field
                                name={`Behavior[${index}].value`}
                                type="text"
                                maxLength="2"
                                label="Value"
                                component={renderTextField}
                                normalize={isInteger}
                                disabled={ this.props.updatePermissionBehavior ? false: true}
                                onChange={(event) => this.deBounceHandleValueChange(event, Obj, 'VALUE',`Behavior[${index}].value`)}
                            />
                    </td>
                    <td>
                        {this.props.deletePermissionBehavior && <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont">
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>}
                    </td>
                </tr>
            )
        })
    }

    renderPatientRecordRateDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientTodaysRecordRateDataList } = this.props;
        let PatientTodaysRecordRateDataList = (patientTodaysRecordRateDataList && patientTodaysRecordRateDataList.data.PatRecordRateData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="25%">Category Name</th>
                                            <th width="30%">Session Date</th>
                                            <th width="20%">Duration</th>
                                            <th width="15%">Value</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientTodaysRecordRateDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientRecordRateDataList()}
                </Dialog>}
            </div>
        )
    }
}
RecordRateDataViewModal = reduxForm({
    form: 'RecordRateDataViewModalForm',
    //enableReinitialize: true,
})(RecordRateDataViewModal);

function mapStateToProps(state) {
    return {
        loading: state.patientBehaviourData.loading,
        patientTodaysRecordRateDataList: state.patientBehaviourData.patientTodaysRecordRateDataList
    }
}

export default connect(mapStateToProps, { PatientTodaysRecordRateDataListAction, deletePatientTodaysRecordRateDataAction,UpdateCollectedBehaviorData,SavePatientRecordRateData })(RecordRateDataViewModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordRate/RecordRateDataViewModal.js